import apiService from '@/services/api.service'
import { ConsentAwareContract } from '@/services/contracts/consent-aware.contract'
import appStore from '@/stores/app.store'

class AbTastyService implements ConsentAwareContract {
  private campaignHandler = () => this.syncWithBackend()

  public activate(): void | Promise<void> {
    /**
     * Every time a campaign is successfully executed, an event is sent with some useful information about the campaign.
     * @see https://developers.abtasty.com/docs/tag/tag-javascript-events#executed-campaign-
     */
    window.addEventListener('abtasty_executedCampaign', this.campaignHandler)
    this.loadScript()
  }

  public deactivate(): void | Promise<void> {
    window.removeEventListener('abtasty_executedCampaign', this.campaignHandler)
    this.deleteCookies()
  }

  private syncWithBackend() {
    const abtasty = window.ABTasty || null
    const visitorId = this.getVisitorId()

    if (abtasty === null) {
      console.warn('ABTasty not found')
      return
    }

    if (visitorId === null) {
      console.warn('Visitor ID not found')
      return
    }

    const assignments = []

    for (const [campaignId, campaignData] of Object.entries(abtasty.results)) {
      if (typeof campaignData !== 'object' || campaignData === null) {
        continue
      }

      if (
        typeof campaignData.variationID === 'undefined' ||
        campaignData.variationID === null
      ) {
        console.warn('No variationID found for campaign', campaignId)
        continue
      }

      assignments.push({
        campaignId: campaignId,
        variationId: campaignData.variationID,
        visitorId: visitorId,
      })
    }

    if (assignments.length > 0) {
      apiService.experimentAssignments
        .store(assignments)
        .then((response) => {
          console.debug('[AB Tasty] Experiment assigned', response)
        })
        .catch((error) => {
          console.error('Failed to assign experiment', error)
        })
    }
  }

  public getVisitorId(): string | null {
    return window.ABTasty?.visitor?.id ?? null
  }

  public getAllocatedVariationName(campaignId: number): string | null {
    return window.ABTasty?.results[campaignId]?.variationName ?? null
  }

  public getStatus(campaignId: number): string | null {
    return window.ABTasty?.results[campaignId]?.status ?? null
  }

  private loadScript() {
    if (!appStore.state.abTastyLoaded) {
      appStore.setAbTastyLoaded(true)
      const ab = document.createElement('script')
      ab.type = 'text/javascript'
      ab.src = appStore.state.isB2b
        ? 'https://try.abtasty.com/f2569426ef605601db7fccc945f7036b.js'
        : 'https://try.abtasty.com/19ef19c343ab4f373c3a82dbcba02e7a.js'
      document.getElementsByTagName('head')[0].appendChild(ab)
    }
  }

  private deleteCookies() {
    document.cookie = `ABTasty=; path=/; expires=Thu, 01 Jan 1900 00:00:00 UTC; Secure SameSite=None`
    document.cookie = `ABTastySession=; path=/; expires=Thu, 01 Jan 1900 00:00:00 UTC; Secure SameSite=None`
  }
}

export default new AbTastyService()
